import { Route, Switch, Redirect, useHistory } from 'react-router';
import { StyledRouterTabs, StyledRoutes, StyledTabs } from './RouterTabs.style';
import TabList from 'components/TabList';
import { noop } from 'lodash';

/**
 * RouterTabs is binding a connection between the Tabs and Routes.
 * Tab will render a component if the url matches the tab's path
 * @param {[RouterTab]} tabs
 * @returns {JSX.Element} The rendered component.
 */
const RouterTabs = ({ tabs = [], withTabs = true }) => {
  const history = useHistory();
  if (tabs.length === 0) return null;

  const defaultTab = tabs.find(tab => tab.isDefault) || tabs[0];

  const selectedTab = tabs.find(tab =>
    history.location.pathname.includes(tab.path)
  );

  const onTabClick = ({ path, search, onClick = noop }) => {
    onClick();
    history.push({
      pathname: path,
      search
    });
  };

  const RedirectToDefault = () => {
    const isDefaultRoute = defaultTab.path === history.location.pathname;
    const { search } = defaultTab;

    if (!isDefaultRoute)
      return (
        <Redirect
          to={{
            pathname: defaultTab.path,
            search
          }}
        />
      );

    return null;
  };

  return (
    <StyledRouterTabs>
      {withTabs && (
        <StyledTabs>
          <TabList
            display='inSpacedSection'
            tabs={tabs}
            onTabClick={onTabClick}
            selectedTab={selectedTab?.name || ''}
          />
        </StyledTabs>
      )}

      <StyledRoutes>
        <Switch>
          {tabs.map(tab => {
            const { subRoutes = [] } = tab;
            const tabRoutes = [tab, ...subRoutes];
            return tabRoutes.map(tab => (
              <Route
                key={tab.path}
                exact={tab.isExact ?? true}
                path={tab.path}
                render={() => tab.component}
              />
            ));
          })}
          <Route path='*' component={RedirectToDefault} />
        </Switch>
      </StyledRoutes>
    </StyledRouterTabs>
  );
};

export default RouterTabs;
